import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useBodyClass } from "hooks/useBodyClass";
import { useSettings } from "providers/settings-provider";
import { Footer } from "./Header/footer";
import { Header } from "./Header/header";
import { Navbar } from "./Header/navbar";
import { BreadCrumb, Container } from "components/atoms";
import { useDispatch } from "react-redux";
import { GetMeAction } from "store/middlewares/me";

export function Layout({ children }) {
  const dispatch = useDispatch();
  const { setOption } = useSettings();

  useEffect(() => {
    // Set current layout
    setOption("layout", "demo2");
  }, [setOption]);

  useBodyClass(`
    [--header-height-default:100px]  
    data-[sticky-header=on]:[--header-height:60px]
    [--header-height:var(--header-height-default)]	
  `);

  useEffect(() => {
    dispatch(GetMeAction());
  }, [dispatch]);

  return (
    <>
      {/* <Helmet>
        <title>{item?.title}</title>
      </Helmet> */}
      <div className="flex grow flex-col min-h-screen max-w-[1280px] mx-auto">
        <div className="mb-5 lg:mb-8 sticky top-0 bg-[#fff] z-20">
          <Header />
          <Navbar />
        </div>

        <main className="grow" role="content">
          {/* <Toolbar>
              <ToolbarHeading />
            </Toolbar> */}
          <Container>
            <BreadCrumb />
            {children ? children : <Outlet />}
          </Container>
        </main>
        <Footer />
      </div>
    </>
  );
}
